import React from "react";
import { Link } from "gatsby";
import * as styles from "../../scss/footer.module.scss";
import Button from "../elements/Button";
import SpectoryLogoAnimated from "../elements/SpectoryLogoAnimated";

const Footer = (props) => {

  return (
    <div className={styles.footerWrapper}>
      <div className={`${styles.prefooter} container fullwidth`}>
        <div className={`container ${styles.prefooterContent}`}>
          <div className={`col5`}>
            <div className={styles.content}>
              <h2 className={styles.heading}>
                Mehr über unser Unternehmen erfahren
              </h2>
              <Button type="primary" aria_label="Erfahren Sie mehr über unser Unternehmen" destination={props.path === "/" ? '/unternehmen' : '/#icons'} text="Erfahren Sie mehr" />
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.footer} container fullwidth`}>
        <div className={`${styles.footerContent} container`}>
          <div className={styles.upperLine}>
            <div className={`${styles.upperLinks} col5`}>
              <Link to="/kontakt">Kontakt</Link>
              <Link to="/datenschutz">Datenschutz</Link>
              <Link to="/impressum">Impressum</Link>
            </div>

          </div>
          <div className={styles.lowerLine}>
            <p>© Copyright 2022 go4digital.<br /><br /><SpectoryLogoAnimated /></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
